var map = {
	"./icon-add copy.png": 1544,
	"./icon-add.png": 1150,
	"./icon-admin.png": 1545,
	"./icon-admin2.png": 1546,
	"./icon-arrowdown-black.png": 1152,
	"./icon-arrowdown.png": 653,
	"./icon-arrowup-black.png": 1153,
	"./icon-arrowup.png": 654,
	"./icon-avatar.png": 1547,
	"./icon-booking.png": 1548,
	"./icon-checked-disabled.png": 1549,
	"./icon-checked-red.png": 1550,
	"./icon-checked.png": 1149,
	"./icon-close.png": 297,
	"./icon-closeburger-white.png": 1551,
	"./icon-closeburger.png": 652,
	"./icon-csv.png": 1552,
	"./icon-dashboard.png": 1553,
	"./icon-dashboard2.png": 1554,
	"./icon-delete.png": 639,
	"./icon-demand-2.png": 641,
	"./icon-demand.png": 1555,
	"./icon-download.png": 1556,
	"./icon-drilldown.png": 1557,
	"./icon-edit.png": 638,
	"./icon-excel.png": 1558,
	"./icon-hamburger-white.png": 1559,
	"./icon-hamburger.png": 651,
	"./icon-home.png": 1560,
	"./icon-info-white.png": 1561,
	"./icon-info.png": 309,
	"./icon-inventory.png": 1562,
	"./icon-part.png": 1563,
	"./icon-part2.png": 1564,
	"./icon-report.png": 534,
	"./icon-report2.png": 1565,
	"./icon-save.png": 1151,
	"./icon-settings.png": 1566,
	"./icon-settings2.png": 1567,
	"./icon-suggestions.png": 533,
	"./icon-suggestions2.png": 1568,
	"./icon-support.png": 1569,
	"./icon-support2.png": 1570,
	"./icon-unchecked-disabled.png": 1571,
	"./icon-unchecked.png": 1572,
	"./icon-vendor.png": 1573,
	"./icon-warning.png": 650
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1543;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/icon\-.*\.png$
// module id = 1543
// module chunks = 0